import { render } from "./UpdateLogsModal.vue?vue&type=template&id=09dd6606&scoped=true"
import script from "./UpdateLogsModal.vue?vue&type=script&lang=js"
export * from "./UpdateLogsModal.vue?vue&type=script&lang=js"

import "./UpdateLogsModal.vue?vue&type=style&index=0&id=09dd6606&scoped=true&lang=css"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09dd6606"]])

export default __exports__